import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { HeroSection } from './components/HeroSection';
import { SocialProofSection } from './components/SocialProofSection';
import { PainPointsSection } from './components/PainPointsSection';
import { ProductDetailsSection } from './components/ProductDetailsSection';
import { TransformationSection } from './components/TransformationSection';
import { OfferSection } from './components/OfferSection';
import { TestimonialsRow2 } from './components/TestimonialsRow2';
import { FAQSection } from './components/FAQSection';
import { FooterSection } from './components/FooterSection';
export function App() {
  return <div className="min-h-screen bg-gradient-to-b from-slate-50 via-purple-50/40 to-blue-50 font-sans text-slate-700 selection:bg-violet-200 selection:text-violet-900" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <HeroSection data-id="element-2" />
      <SocialProofSection data-id="element-3" />
      <PainPointsSection data-id="element-4" />
      <ProductDetailsSection data-id="element-5" />
      <TransformationSection data-id="element-6" />
      <OfferSection data-id="element-7" />
      <TestimonialsRow2 data-id="element-8" />
      <FAQSection data-id="element-9" />
      <FooterSection data-id="element-10" />
    </div>;
}